import { render, staticRenderFns } from "./advertisementPut.vue?vue&type=template&id=7615a6b4&scoped=true"
import script from "./advertisementPut.vue?vue&type=script&lang=js"
export * from "./advertisementPut.vue?vue&type=script&lang=js"
import style0 from "./advertisementPut.vue?vue&type=style&index=0&id=7615a6b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7615a6b4",
  null
  
)

export default component.exports